import { Info } from "lucide-react";
import { formatToCurrency } from "@utils/formatting";
import {
  Tooltip as TooltipWrapper,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@shared-kernel/primary/shared/shadcn/ui/tooltip";

interface Props {
  balance: number;
}

const TOOLTIP_TEXT = "Les professeurs peuvent déclarer les cours en retard, veuillez en tenir compte pour déterminer votre solde réel.";

export const StudentBalanceTopbar = ({ balance }: Props) => {
  return (
    <div className="mx-auto flex items-center justify-center gap-2">
      <div className="flex items-center gap-1">
        <span className="text-sm text-muted-foreground">Solde</span>
        <TooltipProvider>
          <TooltipWrapper>
            <TooltipTrigger asChild>
              <Info size={14} className="cursor-help text-muted-foreground" />
            </TooltipTrigger>
            <TooltipContent>
              <p className="max-w-xs text-sm">{TOOLTIP_TEXT}</p>
            </TooltipContent>
          </TooltipWrapper>
        </TooltipProvider>
      </div>
      <span className="text-xl font-bold">{formatToCurrency(balance)}</span>
    </div>
  );
};
